export default __webpack_public_path__ + "static/moon-87bdcc415290745fbafdbe3b89992dbd.webp";